import axios from 'axios'
import 'url-search-params-polyfill'
import { get } from 'lodash'

import setActiveStep from './setActiveStepActions'
import fetchPackages from './fetchPackages'

import { setActiveLoyalty } from './setActiveSearchFilters'

export const FETCH_LOYALTY_BEGIN = 'FETCH_LOYALTY_BEGIN'
export const FETCH_LOYALTY_SUCCESS = 'FETCH_LOYALTY_SUCCESS'
export const SET_QUERIED_LOYALTY_ID = 'SET_QUERIED_LOYALTY_ID'
export const FETCH_LOYALTY_FAILURE = 'FETCH_LOYALTY_FAILURE'

export const fetchLoyaltyBegin = () => ({
  type: FETCH_LOYALTY_BEGIN
})

export const fetchLoyaltySuccess = loyalty => ({
  type: FETCH_LOYALTY_SUCCESS,
  payload: loyalty
})

export const setQueriedLoyaltyId = loyaltyId => ({
  type: SET_QUERIED_LOYALTY_ID,
  payload: loyaltyId
})

export const fetchLoyaltyError = error => ({
  type: FETCH_LOYALTY_FAILURE,
  payload: { error }
})

// Handle Loyalty Fetch & Functionality
export default function fetchLoyalty(loyaltyId, agencyId, brand) {
  return (dispatch, getState) => {
    // Base API path
    const loyaltyBase = process.env.REACT_APP_FLOW_ENDPOINT_URL + 'loyalty/'

    // Formatted API path including base and params
    const loyaltyApi = loyaltyBase + loyaltyId + '?agencyId=' + agencyId

    dispatch(fetchLoyaltyBegin())
    return axios
      .get(loyaltyApi)
      .then(response => {
        const loyaltyTierCode = get(response, 'data.member.LoyaltyTierCode', '')
        const loyaltyTierBrand = get(
          response,
          'data.member.LoyaltyTierBrand',
          ''
        )
        const key = response.data.id + '-' + response.data.agencyId

        const brandMismatch =
          brand &&
          loyaltyTierBrand &&
          !brand.split(',').includes(loyaltyTierBrand)

        const loyaltyData = {
          [key]: {
            id: response.data.id,
            agency: response.data.agencyId,
            member: brandMismatch ? null : response.data.member,
            error: brandMismatch
              ? 'Loyalty number does not match the selected brand.'
              : response.data.error,
            loyaltyTierCode
          }
        }

        dispatch(fetchLoyaltySuccess(loyaltyData))
        dispatch(setQueriedLoyaltyId(response.data.id))

        if (!brandMismatch && loyaltyData[key].member) {
          const loyaltyId = loyaltyData[key].member.LoyaltyNumber
          dispatch(setActiveLoyalty(loyaltyId, loyaltyTierCode))
        }
      })
      .catch(error => {
        dispatch(fetchLoyaltyError(error))
      })
  }
}
